import { faXmark } from '@document-crunch/pro-regular-svg-icons'

import { Icon } from '@dc-shared-web/components/base'
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
} from '@dc-shared-web/components/shadcn'
import { useState } from 'react'
import { cn } from '@dc-shared-web/lib'

const ChatDisclaimer = ({
  open,
  acknowledged,
  onClose,
}: {
  open: boolean
  acknowledged: boolean
  onClose: () => void
}) => {
  const [confirmed, setConfirmed] = useState(!!acknowledged)

  return (
    <Dialog open={open}>
      <DialogContent
        className='md:tw-w-[520px]'
        data-testid='chat-disclaimer-content'
      >
        <div className='tw-flex tw-content-between'>
          <h1 className='tw-font-medium tw-truncate tw-w-full tw-text-neutral-700 tw-text-base'>
            Disclaimer
          </h1>
          {acknowledged && (
            <Button
              className='tw-p-0 tw--mt-2 tw--mr-2'
              data-testid={`share-modal-close-btn`}
              variant='ghost'
              size={'icon'}
              onClick={onClose}
            >
              <Icon icon={faXmark} size='xl' className='tw-text-neutral-400' />
            </Button>
          )}
        </div>
        <div className='tw-flex tw-flex-col tw-gap-4'>
          <p className='tw-text-sm'>Before you start…</p>
          <p className='tw-text-sm'>
            You&apos;re about to use Document Crunch Chat, an AI tool that helps
            you understand what&apos;s in your construction contract. Keep in
            mind that responses are AI-generated, and we cannot guarantee their
            accuracy. They should not be considered legal advice; consult a
            legal professional for crucial matters. Document Crunch does not
            assume any responsibility or liability for the use or interpretation
            of this content.
          </p>
          <p className='tw-text-sm'>
            We provide page references, whenever possible, and we encourage you
            to use them to validate responses with relevant contract language.
            We also record sessions for quality and feedback purposes.
          </p>
          <p className='tw-text-sm'>
            Before you proceed, you must acknowledge this message by checking
            the box below.
          </p>
        </div>
        <div className='tw-flex tw-gap-3 tw-items-center'>
          <div className='tw-h-[40px] tw-pt-1'>
            <Checkbox
              checked={confirmed}
              disabled={acknowledged}
              className={cn(
                'tw-border-0 tw-flex tw-justify-center tw-items-center tw-h-4 tw-w-4 tw-shrink-0 tw-rounded-sm',
                confirmed
                  ? 'tw-rounded-sm tw-bg-blue-600 tw-accent-primary hover:tw-bg-blue-600 hover:tw-accent-primary'
                  : 'tw-rounded-sm tw-bg-neutral-100'
              )}
              onCheckedChange={() => setConfirmed(!confirmed)}
              data-testid='chat-disclaimer-checkbox'
            />
          </div>
          <span className='tw-text-sm'>
            I understand that no attorney-client relationship has been
            established between myself and Document Crunch
          </span>
        </div>
        <div className='tw-flex tw-w-full tw-justify-end'>
          <Button
            onClick={onClose}
            disabled={!confirmed}
            data-testid='chat-disclaimer-continue-btn'
          >
            {acknowledged ? 'Close' : 'Continue'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ChatDisclaimer
